import script from "./TreeNode.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeNode.vue?vue&type=script&setup=true&lang=js"

import "./TreeNode.vue?vue&type=style&index=0&id=86390be8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86390be8"]])

export default __exports__